import { GetCustomersByRecentProjects, GetCustomersByRecentProjectsToken } from "$src/application/customers/queries/GetCustomersByRecentProjects";
import { PagedResult } from "$src/domain/core/PagedResult";
import { CustomerSummary } from "$src/domain/customers/CustomerSummary";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchCustomersParams {
    queryKey: ['customers', number, number];
}

export async function fetchCustomers( { queryKey } : FetchCustomersParams): Promise<PagedResult<CustomerSummary>> {
    const [_, groupStoreId, pageNumber] = queryKey;
    const query = container.resolve<GetCustomersByRecentProjects>(GetCustomersByRecentProjectsToken);

    return query.execute(groupStoreId, pageNumber, '');
}

export function useCustomers(groupStoreId: number, pageNumber: number) {
    return useQuery<PagedResult<CustomerSummary>, Error, PagedResult<CustomerSummary>, ['customers', number, number]>(
        ['customers', groupStoreId, pageNumber], 
        fetchCustomers,
        {
            staleTime: 30000,
            cacheTime: 60000,
        }
    );
}